import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
export function Modal({ open, onClose, title, children, width = 480 }) {
    useEffect(() => {
        if (!open)
            return;
        const handler = (e) => e.key === "Escape" && onClose();
        document.addEventListener("keydown", handler);
        return () => document.removeEventListener("keydown", handler);
    }, [open, onClose]);
    if (!open)
        return null;
    return (_jsx("div", { className: "fixed inset-0 z-[1000] flex items-center justify-center bg-black/70 p-4 backdrop-blur-md", onClick: (e) => e.target === e.currentTarget && onClose(), children: _jsxs("div", { className: "w-full rounded-2xl border border-white/10 bg-[#0c0c10] p-7 shadow-2xl", style: { maxWidth: width }, role: "dialog", "aria-modal": "true", "aria-label": title, children: [title && (_jsxs("div", { className: "mb-5 flex items-center justify-between gap-4", children: [_jsx("h2", { className: "text-[18px] font-medium text-white", children: title }), _jsx("button", { type: "button", onClick: onClose, "aria-label": "Close", className: "grid h-11 w-11 place-items-center rounded-full bg-white/8 text-white/70", children: "\u00D7" })] })), children] }) }));
}
